<template>
  <div v-if="hasProducts" class="section dbg">
    <!-- /.container-lg -->

    <div :id="slider.type || 'landing-products'" :data-slider="slider.type || 'landing-products'" class="products-slider">
      <div v-for="product in slider.products"  :key="product.id" class="slider-item dbg">
        <product-landing-item :product="product"/>
      </div>
    </div><!-- /.products-slider -->
  </div>
</template>

<script>

/**
 * LandingSlider.
 *
 * @component
 * @name LandingSlider
 * @props {object} slider - The slider data with products.
 * @props {object} in18 - Internationalization data.
 */

import ProductLandingItem from "../product-item/ProductLandingItem.vue";


export default {
  name:     "LandingSlider",
  props:    [
    'in18',
    'slider',
  ],
  components: {
    ProductLandingItem,
  },
  computed: {
    /**
     * Check if there are products in the slider.
     *
     * @member {boolean}
     * @property {boolean} hasProducts - True if there are products, otherwise false.
     */
    hasProducts() {
      return (
          this.slider &&
          this.slider.is_active &&
          this.slider.products &&
          this.slider.products.length > 0
      );
    },
  },
  mounted() {
    this.activateSlick();
  },
  methods: {


      handleClick() {
        window.location.href = this.product.link;
      },


    /**
     * Activate the Slick slider.
     *
     * @method
     */
    activateSlick() {

      $("[data-slider='" + (this.slider.type || 'landing-products') + "']").slick({
        autoplay:       true,
        autoplaySpeed:  3000,
        infinite:       true,
        slidesToShow:   4,
        slidesToScroll: 1,
        arrows:         true,
        dots:           false,
        speed:          600,
        variableWidth:  false,
        centerMode:     false,
        lazyLoad:       'ondemand',
        responsive:     [
          {
            breakpoint: 1200,
            settings:   {
              slidesToShow: 3
            },
          },
          {
            breakpoint: 880,
            settings:   {
              slidesToShow: 2
            },
          },
          {
            breakpoint: 480,
            settings:   {
              slidesToShow: 1
            },
          }
        ]
      });
    }
  },
};
</script>

